import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-video-icon',
    templateUrl: './video-icon.component.html',
    styleUrls: ['./video-icon.component.scss'],
    standalone: false
})
export class VideoIconComponent implements OnInit, OnDestroy {
  param: any;
  check: any;
  UrlFeed: any;
  isShowClose: string;
  setClass: string;
  showLoading = true;

  private eventsSubscription: Subscription;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('videoModal') videoModal: ElementRef;

  @Input() events: Observable<void>;
  @Input('VideoUrl') VideoUrl: any;
  @Input() isIconHide: boolean = false;
  @Input() href: any;

  // Every instance renders a modal with this id and targets it by id, so when a
  // page holds more than one video icon they all collide and bootstrap opens the
  // first one in the DOM. Pass a unique id to opt an instance out of that.
  // Left as "myModal" by default: a global #myModal rule in create-expense.scss
  // and watch-video.component rely on the original id.
  @Input() modalId: string = 'myModal';

  private get modalIframeSelector(): string {
    return '#' + this.modalId + ' iframe';
  }

  constructor() {

  }

  ngOnInit() {
    this.showLoading = true;
    if (this.events) {
      this.eventsSubscription = this.events.subscribe(() => this.showVideo());
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  private fnGetModalIframe(): HTMLIFrameElement {
    // this instance's own iframe first, so several video icons on one page do
    // not reset each other's player
    const modalElement = this.videoModal?.nativeElement as HTMLElement;

    return (modalElement?.querySelector('iframe')
      ?? document.querySelector(this.modalIframeSelector)) as HTMLIFrameElement;
  }

  close(value) {
    this.check = value;
    var iframe = this.fnGetModalIframe();

    // reassigning src reloads the frame, which stops playback on close
    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }
  }

  afterHidden(value) {
    // your code here
    this.check = value;
    var iframe = this.fnGetModalIframe();

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;

    }
  }

  IsvideoActive(value) {
    this.check = value;
    var iframe = this.fnGetModalIframe();

    if (iframe) {
      this.setClass = iframe.src.indexOf('vimeo') > -1 ? 'video-height-vimeo' : 'video-height-youtube';
    }
  }

  showVideo() {
    this.IsvideoActive(true);
    this.fnOpenModal();
  }
  showVideofromother(value) {
    this.IsvideoActive(value);
    this.fnOpenModal();
  }

  // Opens this instance's modal through the bootstrap API rather than relying on
  // the data-bs-toggle handler: a programmatic click on the hidden anchor does
  // not reliably reach it, so triggering the video from code did nothing.
  private fnOpenModal() {
    const modalElement = this.videoModal?.nativeElement as HTMLElement;
    const bootstrapRef = (window as any).bootstrap;

    if (modalElement && bootstrapRef?.Modal) {
      bootstrapRef.Modal.getOrCreateInstance(modalElement).show();
      return;
    }

    // fall back to the markup trigger if bootstrap is not on the window
    const inputElement = this.fileInput?.nativeElement as HTMLElement;
    inputElement?.click();
  }

  onLoad() {
    setTimeout(() => {
      this.showLoading = false;
  }, 2500);
    
  }

}



